module.exports = __webpack_public_path__ + "img/m-about-no.6b316b52.webp";